export const colorCode = {
  baseGreen: "#90CE88",
  dimGreen: "#7FB578",
  gray: "#999999",
} as const;
